import { ConnectedUserDto } from '../services/dtos/connected-user-dto';
import { MandateDto, TabType } from '../services/dtos/mandate.dto';
import { UserAccountDto } from '../services/dtos/user-account.dto';
import { ROLE_ADMIN, ROLE_BASIC, ROLE_PRESIDENT } from './constants.util';

const BASIC_ALLOWED_TABS = [TabType.MEETING, TabType.MEETINGFILE, TabType.COMPOSITION, TabType.DOCUMENTS, TabType.COMMISSIONS];
const PRESIDENT_MANDATE_PREFIX = 'ROLE_PRESIDENT_MANDATE_';

export const isAdminUser = (connectedUser: ConnectedUserDto | null | undefined): boolean =>
    !connectedUser?.emailLoggedInAS && (connectedUser?.roles?.includes(ROLE_ADMIN) ?? false);

export const canAccessAllTabs = (accessRole?: string): boolean =>
    accessRole === ROLE_ADMIN || accessRole === ROLE_PRESIDENT;

export const resolveMandateAccessRole = (
    mandate: MandateDto | null | undefined,
    connectedUser: ConnectedUserDto | null | undefined,
    userAccount: UserAccountDto | null | undefined
): string => {
    if (isAdminUser(connectedUser)) {
        return ROLE_ADMIN;
    }

    if (mandate?.id && userAccount?.roles?.includes(`${PRESIDENT_MANDATE_PREFIX}${mandate.id}`)) {
        return ROLE_PRESIDENT;
    }

    return mandate?.accessRole ?? ROLE_BASIC;
};

export const resolveCommissionAccessRole = (
    userAccount: UserAccountDto | null | undefined,
    connectedUser: ConnectedUserDto | null | undefined
): string => resolveMandateAccessRole(
    userAccount?.mandateCommissions ?? userAccount?.mandateAssGeneral,
    connectedUser,
    userAccount
);

export const filterTabsByAccessRole = (tabs: TabType[], accessRole: string): TabType[] => {
    if (canAccessAllTabs(accessRole)) {
        return tabs;
    }

    if (accessRole === ROLE_BASIC) {
        return tabs.filter(tab => BASIC_ALLOWED_TABS.includes(tab));
    }

    return tabs;
};
